export enum AppointmentAcceptanceOptionEnum {
  MANUAL_ATTACHMENT = 'ATTACH_ACCEPTANCE_DECLARATION',       // إرفاق إقرار بقبول التعيين
  POWER_OF_ATTORNEY = 'POWER_OF_ATTORNEY',       // عن طريق توكيل يتضمن صلاحية التعامل
  ELECTRONIC_SIGNATURE = 'GENERATE_AND_ESIGN_ACCEPTANCE_DECLARATION', // إصدار إقرار بقبول التعيين وتوقيعه إلكترونيًا
}

export interface AppointmentAcceptanceOption {
  code: string;
  arLabel: string;
  hint?:string
}

export const APPOINTMENT_ACCEPTANCE_OPTIONS: AppointmentAcceptanceOption[] = [
  { code: AppointmentAcceptanceOptionEnum.MANUAL_ATTACHMENT, arLabel: 'إرفاق إقرار بقبول التعيين' },
  { code: AppointmentAcceptanceOptionEnum.POWER_OF_ATTORNEY, arLabel: 'عن طريق توكيل يتضمن صلاحية التعامل' },
  { code: AppointmentAcceptanceOptionEnum.ELECTRONIC_SIGNATURE, arLabel: 'إصدار إقرار بقبول التعيين وتوقيعه إلكترونيًا' },
];
